/**
 * use-async-interval.js
 * https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * 
 * NOTE: this varies from the typical useInterval in that it does not fire exactly
 * after every delay but waits for the async callback to return before starting the timer again.
 */

import React from 'react';


export default function useAsyncInterval(callback, delay, runOnInit, ...args) {
  const savedCallback = React.useRef();
  const timeout = React.useRef();
  const argString = JSON.stringify(args);


  // Remember the latest callback.
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);


  // Set up the interval.
  React.useEffect(() => {
    const fire = async () => {
      const args = JSON.parse(argString);
      await savedCallback.current(...args);
      timeout.current = setTimeout(fire, delay);
    }

    (async() => {
      if (runOnInit) {
        const args = JSON.parse(argString);
        await savedCallback.current(...args);
      }
      
      timeout.current = setTimeout(fire, delay);
    })();
    
    return () => {
      clearTimeout(timeout.current);
    }
  }, [runOnInit, delay, argString]);
}